<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }} @if (grid.grid_key) {
<span>({{ grid.grid_key }})</span>
}
    </h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    @if (!loading) {
<form #gridForm="ngForm" novalidate>

      <!-- ==================== GRID SETTINGS PANEL ==================== -->
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4 style="margin: 0;">Grid {{ grid.grid_key }}</h4>
        </div>
        <div class="panel-body">

          <!-- Row 1: Name, Description, Row Height, Header Height, Fixed Columns -->
          <div class="row gb-field-row">
            <div class="col-md-3">
              <label>Grid Name:</label>
              <input type="text" class="form-control input-sm" required name="grid_name"
                     #gridNameCtrl="ngModel"
                     [(ngModel)]="grid.grid_name">
              @if (gridNameCtrl.invalid && (gridNameCtrl.touched || submitted)) {
<span class="form-error-container"
                   >Grid Name is required.</span>
}
            </div>

            <div class="col-md-3">
              <label>Grid Description:</label>
              <textarea class="form-control" required name="grid_desc" style="width: 100%; min-height: 90px"
                        #gridDescCtrl="ngModel"
                        [(ngModel)]="grid.grid_desc"></textarea>
              @if (gridDescCtrl.invalid && (gridDescCtrl.touched || submitted)) {
<span class="form-error-container"
                   >Grid Description is required.</span>
}
            </div>

            <div class="col-md-1">
              <label>Grid Row Height:</label>
              <input type="number" name="row_height" required min="20" max="50" class="form-control input-sm"
                     #rowHeightCtrl="ngModel"
                     [(ngModel)]="grid.default_row_height">
              @if (rowHeightCtrl.invalid && (rowHeightCtrl.touched || submitted)) {
<span class="form-error-container"
                   >
                @if (rowHeightCtrl.errors?.required) {
<span>Row Height is required.</span>
}
                @if (rowHeightCtrl.errors?.min || rowHeightCtrl.errors?.max) {
<span>Value must be 20-50.</span>
}
              </span>
}
            </div>

            <div class="col-md-1">
              <label>Header Height:</label>
              <input type="number" required name="header_height" min="30" max="100" class="form-control input-sm"
                     #headerHeightCtrl="ngModel"
                     [(ngModel)]="grid.header_height">
              @if (headerHeightCtrl.invalid && (headerHeightCtrl.touched || submitted)) {
<span class="form-error-container"
                   >
                @if (headerHeightCtrl.errors?.required) {
<span>Header Height is required.</span>
}
                @if (headerHeightCtrl.errors?.min || headerHeightCtrl.errors?.max) {
<span>Value must be 30-100.</span>
}
              </span>
}
            </div>

            <div class="col-md-1">
              <label>Fixed Columns:</label>
              <input type="number" required name="fixed_columns" min="0" max="10" class="form-control input-sm"
                     #fixedColsCtrl="ngModel"
                     [(ngModel)]="grid.fixed_columns">
              @if (fixedColsCtrl.invalid && (fixedColsCtrl.touched || submitted)) {
<span class="form-error-container"
                   >
                @if (fixedColsCtrl.errors?.required) {
<span>Fixed Columns is required.</span>
}
                @if (fixedColsCtrl.errors?.min || fixedColsCtrl.errors?.max) {
<span>Value must be 0-10.</span>
}
              </span>
}
            </div>
          </div>

          <!-- Row 2: Grid Type, Checkboxes, Conditional fields -->
          <div class="row gb-field-row" style="margin-top: 12px;">
            <div class="col-md-2">
              <label>Grid Type:</label>
              <select class="form-control" name="grid_type" required
                      [(ngModel)]="grid.grid_type">
                @for (t of gridTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
              </select>
            </div>

            @if (grid.grid_type === 'import') {
<div class="col-md-3">
              <label>Max xls Rows:</label>
              <input type="number" class="form-control input-sm" required name="max_xls_rows"
                     [(ngModel)]="grid.max_xls_rows">
            </div>
}

            <div class="col-md-1 gb-checkbox-field">
              <label>Expand Columns:</label>
              <input type="checkbox" name="expand_cols"
                     [ngModel]="grid.expand_cols == 1"
                     (ngModelChange)="grid.expand_cols = $event ? 1 : 0">
            </div>

            <div class="col-md-1 gb-checkbox-field">
              <label>Allow Comments:</label>
              <input type="checkbox" name="comments"
                     [ngModel]="grid.comments == 1"
                     (ngModelChange)="grid.comments = $event ? 1 : 0">
            </div>

            <div class="col-md-1 gb-checkbox-field">
              <label>Documentation:</label>
              <input type="checkbox" name="documentation"
                     [ngModel]="grid.documentation == 1"
                     (ngModelChange)="grid.documentation = $event ? 1 : 0; documentMap()">
            </div>

            <div class="col-md-1 gb-checkbox-field">
              <label>Batch Select:</label>
              <input type="checkbox" name="batch_select"
                     [ngModel]="grid.batch_select == 1"
                     (ngModelChange)="grid.batch_select = $event ? 1 : 0; documentMap()">
            </div>

            @if (grid.documentation == 1 && grid.batch_select == 1 && grid.headers.length > 0) {
<div class="col-md-2">
              <label>Unique Key (Document):</label>
              <select class="form-control" name="doc_header_key"
                      [(ngModel)]="grid.doc_header_key">
                <option value="">none</option>
                @for (h of grid.headers; track $index) {
<option [value]="h.map">{{ h.map }}</option>
}
              </select>
            </div>
}

            @if (grid.documentation == 1 && grid.batch_select == 1 && grid.headers.length > 0) {
<div class="col-md-2">
              <label>Type (Document):</label>
              <select class="form-control" name="doc_header_type"
                      [(ngModel)]="grid.doc_header_type">
                <option value="">none</option>
                @for (h of grid.headers; track $index) {
<option [value]="h.map">{{ h.map }}</option>
}
              </select>
            </div>
}

            <div class="col-md-1 gb-checkbox-field">
              <label>Audit Cells</label>
              <input type="checkbox" name="audit_cells"
                     [ngModel]="grid.audit_cells == 1"
                     (ngModelChange)="grid.audit_cells = $event ? 1 : 0">
            </div>

            @if (grid.grid_type === 'import') {
<div class="col-md-1 gb-checkbox-field">
              <label>Grid Validation</label>
              <input type="checkbox" name="screen_validation"
                     [ngModel]="grid.screen_validation == 1"
                     (ngModelChange)="grid.screen_validation = $event ? 1 : 0">
            </div>
}
          </div>

          <!-- Batch Select Panel -->
          @if (grid.batch_select == 1) {
<div class="panel panel-default" style="margin-top: 12px;">
            <div class="panel-heading">
              <h4 style="margin: 0;">Batch Select</h4>
            </div>
            <div class="panel-body">
              <div class="row gb-field-row">
                <div class="col-md-3">
                  <label>Batch Select Rules:</label>
                  <textarea class="form-control" name="batch_select_rules"
                            placeholder="Enter the batch selection rules..."
                            [(ngModel)]="grid.batch_select_rules"
                            (ngModelChange)="updateJsonObject()"></textarea>
                  @if (isValid) {
<b style="color: green">Valid Json</b>
}
                  @if (!isValid) {
<b style="color: red">Invalid Json</b>
}
                </div>
                <div class="col-md-3">
                  <label>Batch Select Rules Message:</label>
                  <input type="text" name="batch_rule_message" class="form-control" style="height: 55px"
                         placeholder="You can not select this row, LEID can not be D18301"
                         [(ngModel)]="grid.batch_rule_message">
                </div>
                @if (grid.batch_select == 1 && grid.grid_key) {
<div class="col-md-2">
                  <button class="btn btn-sm btn-success" style="margin-top: 24px;" (click)="addBatchAction()">
                    Add Batch Action &nbsp;<i class="fa fa-plus-circle"></i>
                  </button>
                </div>
}
              </div>

              <div class="row" style="margin-top: 10px;">
                <div class="col-md-12">
                  <label>Saved Action Names:</label>
                  <div class="well user-well-xs well-xs" style="margin-right: 5px;">
                    @for (labelName of actionNames; track $index) {
<div
                         style="margin: 0 5px 5px 0; display: inline-block;"
                         class="btn-group btn-group-xs" role="group">
                      <div class="btn btn-xs btn-default" (click)="editGridAction(labelName)">
                        <i class="fa fa-pencil"></i>
                      </div>
                      <div class="btn btn-default btn-xs btn-white">{{ labelName.name }}</div>
                      <div class="btn btn-danger btn-xs"
                           (click)="confirmRemoveAction(labelName.grid_action_key)">
                        <i class="fa fa-times"></i>
                      </div>
                    </div>
}
                    @if (actionNames.length === 0) {
<span style="color: #999;">No actions defined</span>
}
                  </div>
                </div>
              </div>
            </div>
          </div>
}

          <!-- API Key (edit mode only) -->
          @if (!isNew) {
<div class="row gb-field-row" style="margin-top: 12px;">
            <div class="col-md-6">
              <label>API Key:</label>
              <div class="input-group">
                <input type="text" class="form-control"
                       [ngModel]="apiKey" name="api_key" readonly>
                <span class="input-group-addon btn btn-default" (click)="copyClipboard()">copy</span>
              </div>
              <span style="color: green;">{{ copyMessage }}</span>
            </div>
          </div>
}

        </div>
      </div>

      <!-- ==================== GRID IMPORT VALIDATION PANEL ==================== -->
      @if (grid.screen_validation == 1) {
<div class="panel panel-default">
        <div class="panel-heading" style="cursor: pointer;"
             (click)="screenValidationOpen = !screenValidationOpen">
          <h4 style="margin: 0; display: inline;">Grid Import Validation</h4>
          <span style="float: right;">
            <i class="glyphicon"
               [ngClass]="screenValidationOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-up'"></i>
          </span>
        </div>
        @if (screenValidationOpen) {
<div class="panel-body">
          @for (rule of screenValidationRules; track $index; let ri = $index) {
<div class="row gb-field-row"
               style="margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #eee;">
            <div style="flex: 0 0 40px; text-align: center; padding-top: 24px;">
              @if (ri === 0) {
<i class="fa fa-plus-circle" style="font-size: 24px; color: green; cursor: pointer;"
                 (click)="addScreenValidationRule()"
                 ap-tooltip [appendAfterTarget]="true" tooltipContent="Add new rule" direction="right"></i>
}
              @if (ri > 0) {
<i class="fa fa-minus-circle color-red" style="font-size: 24px; cursor: pointer;"
                 (click)="removeScreenValidationRule(ri)"
                 ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove rule" direction="right"></i>
}
            </div>
            <div class="col-md-3">
              <label>Screen Validation Rule</label>
              <select class="form-control" [name]="'svr_type_'+ri"
                      [(ngModel)]="rule.rule_type">
                <option value=""></option>
                @for (sr of screenRuleTypes; track $index) {
<option [value]="sr.value">{{ sr.name }}</option>
}
              </select>
            </div>
            <div class="col-md-2">
              <label>Buffer Size</label>
              <input type="number" class="form-control" [name]="'svr_buffer_'+ri"
                     [(ngModel)]="rule.buffer_size">
            </div>
          </div>
}
          @if (screenValidationRules.length === 0) {
<div style="text-align: center; padding: 10px; color: #999;">
            No validation rules defined.
            <button type="button" class="btn btn-sm btn-success" style="margin-left: 8px;"
                    (click)="addScreenValidationRule()">
              Add Rule <i class="fa fa-plus-circle"></i>
            </button>
          </div>
}
        </div>
}
      </div>
}

      <!-- ==================== ARRANGE GRID HEADERS PANEL ==================== -->
      @if (grid.headers.length > 0) {
<div class="panel panel-default">
        <div class="panel-heading" style="cursor: pointer;" (click)="arrangeOpen = !arrangeOpen">
          <h4 style="margin: 0; display: inline;">Arrange Grid Headers</h4>
          <span style="float: right;">
            <i class="glyphicon" [ngClass]="arrangeOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-up'"></i>
          </span>
        </div>
        @if (arrangeOpen && rearrangeItems.length > 0) {
<div class="panel-body">
          <div class="gb-arrange-container"
               (dragover)="onArrangeDragOver($event)"
               (drop)="onArrangeDrop($event)">
            @for (item of rearrangeItems; track $index; let idx = $index) {
<div
                 class="gb-arrange-chip"
                 [class.gb-arrange-chip-selected]="item.selected"
                 [class.gb-arrange-chip-dragging]="arrangeDragIdx === idx"
                 draggable="true"
                 (dragstart)="onArrangeDragStart($event, idx)"
                 (dragenter)="onArrangeDragEnter($event, idx)"
                 (dragend)="onArrangeDragEnd()"
                 (click)="toggleArrangeItem(item)">
              <i class="fa fa-check-circle gb-arrange-check"
                 [class.gb-arrange-check-on]="item.selected"></i>
              <span class="gb-arrange-label">{{ item.label }}</span>
            </div>
}
          </div>
          <div class="gb-arrange-actions">
            <button type="button" (click)="moveArrangeUp()" class="btn btn-default btn-sm"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Move selected up" direction="top">
              <i class="fa fa-arrow-up"></i>
            </button>
            <button type="button" (click)="moveArrangeDown()" class="btn btn-default btn-sm"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Move selected down" direction="top">
              <i class="fa fa-arrow-down"></i>
            </button>
            @if (!isArrangeApplied) {
<button type="button" (click)="resetArrangeOrder()"
                    class="btn btn-warning btn-sm">Reset</button>
}
            <button type="button" (click)="applyArrangeOrder()" class="btn btn-primary btn-sm">Apply</button>
          </div>
        </div>
}
      </div>
}

      <!-- ==================== GRID HEADERS PANEL ==================== -->
      <div class="panel panel-default">
        <div class="panel-heading">
          <h4 style="margin: 0;">Grid Headers</h4>
        </div>
        <div class="panel-body">

          <!-- Pivot grid note -->
          @if (grid.grid_type === 'pivot') {
<div>
            <label>Enter Action Key:</label>
            <input type="text" style="width: 70px" name="pivot_action_key" class="form-control input-sm"
                   [(ngModel)]="grid.action_key">
            <br>
            <h4 style="margin: 0;">Pivot Grid Tools</h4>
            <p>* The Pivot Grid Admin Tools are currently being built. In the mean time you will need a developer to set the grid up.</p>
          </div>
}

          <!-- Non-pivot headers -->
          @if (grid.grid_type !== 'pivot') {
<div>

            <!-- Action Key + Generate / Add / Revert toolbar -->
            <div class="row">
              <div class="panel panel-default">
                <div class="panel-body gb-header-toolbar">

                  @if (isNew) {
<div class="gb-toolbar-action-key">
                    <div class="form-inline">
                      <div class="form-group">
                        <label>Enter Action Key:</label>
                        <div class="input-group">
                          <input type="text" style="width: 50px" name="new_action_key" class="form-control input-sm"
                                 [(ngModel)]="grid.action_key">
                        </div>
                      </div>
                      <div class="btn btn-primary btn-sm" (click)="genHeaders()">Generate Headers</div>
                    </div>
                  </div>
}

                  @if (!isNew && grid.grid_type !== 'import') {
<div class="gb-toolbar-action-key">
                    <div class="form-inline">
                      <div class="form-group">
                        <label>Action Key:</label>
                        <div class="input-group">
                          <div class="input-group-addon">
                            <input type="checkbox" name="action_on" [(ngModel)]="actionOn">
                          </div>
                          <input type="text" [disabled]="!actionOn" style="width: 70px" name="edit_action_key"
                                 class="form-control input-sm" [(ngModel)]="grid.action_key">
                        </div>
                      </div>
                      <button type="button" [disabled]="!actionOn" (click)="genHeaders()"
                              class="btn btn-primary btn-sm">Load New Action</button>
                    </div>
                  </div>
}

                  <div class="gb-toolbar-buttons">
                    <div class="btn btn-sm btn-success" (click)="addHeader()"
                         ap-tooltip [appendAfterTarget]="true" tooltipContent="Add new Header" direction="right">
                      Add new Column <i class="fa fa-plus-circle"></i>
                    </div>
                    @if (!isNew) {
<div class="btn btn-sm btn-warning" (click)="resetHeaders()"
                         ap-tooltip [appendAfterTarget]="true" tooltipContent="Reset Column Header before you started editing" direction="right">
                      Revert Changes <i class="fa fa-refresh"></i>
                    </div>
}
                  </div>

                </div>
              </div>
            </div>

            <!-- Header rows -->
            @for (headerData of grid.headers; track $index; let i = $index; let even = $even) {
<div>
              @if (!isHeaderHidden(headerData)) {

                <div class="gb-header-block"
                     [attr.data-header-idx]="i"
                     [class.gb-header-even]="even"
                     ngModelGroup="header_{{i}}">

                  <!-- Header Row 1: Core fields -->
                  <div class="row gb-header-row">
                    <div class="gb-header-delete-col">
                      <i style="font-size: 24px;" class="fa fa-minus-circle color-red"
                         ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Row" direction="right"
                         (click)="confirmDeleteHeader(i)"></i>
                    </div>

                    <div class="col-md-2">
                      <label>Header Label</label>
                      <input type="text" [(ngModel)]="headerData.label" required [name]="'label_'+i"
                             class="form-control input-sm">
                    </div>

                    <div class="col-md-2">
                      <label>Header Map</label>
                      <input type="text" [(ngModel)]="headerData.map" required [name]="'map_'+i"
                             class="form-control input-sm">
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Display</label>
                      <input type="checkbox"
                             [ngModel]="headerData.display === 'y'"
                             (ngModelChange)="headerData.display = $event ? 'y' : 'n'"
                             [name]="'display_'+i">
                    </div>

                    <div class="col-md-1">
                      <label>Width</label>
                      <input type="number" [name]="'width_'+i" [(ngModel)]="headerData.width"
                             required min="10" max="400" class="form-control input-sm">
                    </div>

                    <div class="col-md-1">
                      <label>Data Type</label>
                      <select class="form-control input-sm" [name]="'data_type_'+i"
                              [(ngModel)]="headerData.data_type"
                              (ngModelChange)="dataTypeToggle(i, headerData.data_type)">
                        @for (t of dataTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Editable</label>
                      <input type="checkbox"
                             [ngModel]="headerData.editable === 'y'"
                             (ngModelChange)="headerData.editable = $event ? 'y' : 'n'"
                             [name]="'editable_'+i">
                    </div>

                    <div class="col-md-1">
                      <label>Edit Type</label>
                      <select class="form-control input-sm" [name]="'edit_type_'+i"
                              [(ngModel)]="headerData.edit_type">
                        <option value=""></option>
                        @for (t of editTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>

                    <div class="col-md-1">
                      <label>Format</label>
                      <select class="form-control input-sm" [name]="'format_'+i"
                              [(ngModel)]="headerData.format">
                        @for (t of formatTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>

                    <div class="col-md-1">
                      <label>Edit Icon</label>
                      <select class="form-control input-sm" [name]="'edit_icon_'+i"
                              [(ngModel)]="headerData.edit_icon">
                        <option value=""></option>
                        @for (t of iconTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>

                    <div class="col-md-1">
                      <label>Validation</label>
                      <select class="form-control input-sm" [name]="'validation_'+i"
                              [(ngModel)]="headerData.validation">
                        @for (t of validationTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>
                  </div>

                  <!-- Header Row 2: Secondary fields -->
                  <div class="row gb-header-row">
                    <div class="gb-header-delete-col"></div>

                    <div class="col-md-1">
                      <label>Transpose</label>
                      <select class="form-control input-sm" [name]="'transpose_'+i"
                              [(ngModel)]="headerData.transpose"
                              (ngModelChange)="transposeToggle(i, headerData.transpose)">
                        @for (t of transposeTypeList; track $index) {
<option [value]="t.value">{{ t.name }}</option>
}
                      </select>
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>New Row Editable</label>
                      <input type="checkbox"
                             [ngModel]="headerData.new_row_editable === '1'"
                             (ngModelChange)="headerData.new_row_editable = $event ? '1' : '0'"
                             [name]="'new_row_editable_'+i">
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Required</label>
                      <input type="checkbox"
                             [ngModel]="headerData.required === '1'"
                             (ngModelChange)="headerData.required = $event ? '1' : '0'"
                             [name]="'required_'+i">
                    </div>

                    <div class="col-md-2">
                      <label>Call Back</label>
                      <input type="text" [(ngModel)]="headerData.call_back" [name]="'call_back_'+i"
                             class="form-control input-sm">
                    </div>

                    <div class="col-md-1">
                      <label>Column Class</label>
                      <input type="text" [(ngModel)]="headerData.col_class" [name]="'col_class_'+i"
                             class="form-control input-sm">
                    </div>

                    <div class="gb-move-col">
                      <i (click)="moveUp(i)"
                         class="fa fa-arrow-circle-up"
                         [class.gb-move-disabled]="isFirstVisible(i)"
                         [style.pointer-events]="isFirstVisible(i) ? 'none' : 'auto'"
                         ap-tooltip [appendAfterTarget]="true" tooltipContent="Move Up" direction="top"></i>
                      <i (click)="moveDown(i)"
                         class="fa fa-arrow-circle-down"
                         [class.gb-move-disabled]="isLastVisible(i)"
                         [style.pointer-events]="isLastVisible(i) ? 'none' : 'auto'"
                         ap-tooltip [appendAfterTarget]="true" tooltipContent="Move Down" direction="top"></i>
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Cell Class</label>
                      <input type="checkbox"
                             [ngModel]="headerData.cell_class === '1'"
                             (ngModelChange)="headerData.cell_class = $event ? '1' : '0'"
                             [name]="'cell_class_'+i">
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Pivot Unique</label>
                      <input type="checkbox"
                             [ngModel]="headerData.pivot_unique_key === '1'"
                             (ngModelChange)="headerData.pivot_unique_key = $event ? '1' : '0'"
                             [name]="'pivot_unique_'+i">
                    </div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Group By Key</label>
                      <input type="checkbox"
                             [ngModel]="headerData.pivot_group_by_key === '1'"
                             (ngModelChange)="headerData.pivot_group_by_key = $event ? '1' : '0'; headerData.pivot_group_by_key === '0' ? headerData.pivot_group_by_data = '' : null"
                             [name]="'group_by_key_'+i">
                    </div>

                    <div class="col-md-1">
                      <label>Group By Data</label>
                      <select class="form-control input-sm" [name]="'group_by_data_'+i"
                              [(ngModel)]="headerData.pivot_group_by_data"
                              [disabled]="headerData.pivot_group_by_key !== '1'">
                        <option value=""></option>
                        @for (opt of groupByDataOptions; track $index) {
<option [value]="opt.value">{{ opt.name }}</option>
}
                      </select>
                    </div>

                    @if (headerData.edit_type === 'dropdown') {
<div class="col-md-2">
                      <label>Dropdown values</label>
                      <textarea [name]="'static_values_'+i" [(ngModel)]="headerData.static_values"
                                class="form-control input-sm"></textarea>
                    </div>
}
                  </div>

                  <!-- Header Row 3: Rules & Drilldown -->
                  <div class="row gb-header-row">
                    <div class="gb-header-delete-col"></div>

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>Apply Rules</label>
                      <input type="checkbox"
                             [ngModel]="headerData.apply_rules === '1'"
                             (ngModelChange)="headerData.apply_rules = $event ? '1' : '0'"
                             [name]="'apply_rules_'+i">
                    </div>

                    @if (headerData.apply_rules === '1') {
<div class="col-md-2">
                      <label>Edit Row Rule:</label>
                      <textarea class="form-control input-sm" placeholder="Enter JSON Object..."
                                [(ngModel)]="headerData.edit_rules" [name]="'edit_rules_'+i"
                                (ngModelChange)="updateJsonObject(headerData)"></textarea>
                      @if (headerData.isValid !== false) {
<b style="color: green">Valid Json</b>
}
                      @if (headerData.isValid === false) {
<b style="color: red">Invalid Json</b>
}
                    </div>
}

                    @if (headerData.apply_rules === '1') {
<div class="col-md-2">
                      <label>Edit Rule Error Message:</label>
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="headerData.edit_rule_message" [name]="'edit_rule_msg_'+i">
                    </div>
}

                    @if (headerData.editable === 'y' && headerData.edit_type === 'text') {
<div class="gb-narrow-col gb-checkbox-field"
                        >
                      <label>Audit Cells</label>
                      <input type="checkbox"
                             [ngModel]="headerData.audit_cells === '1'"
                             (ngModelChange)="headerData.audit_cells = $event ? '1' : '0'"
                             [name]="'hdr_audit_cells_'+i">
                    </div>
}

                    @if (headerData.apply_rules === '1') {
<div class="gb-narrow-col gb-checkbox-field">
                      <label>DrillDown Rule</label>
                      <input type="checkbox"
                             [ngModel]="headerData.drilldown_rule === '1'"
                             (ngModelChange)="headerData.drilldown_rule = $event ? '1' : '0'"
                             [name]="'drilldown_rule_'+i">
                    </div>
}

                    <div class="gb-narrow-col gb-checkbox-field">
                      <label>DrillDown Refresh</label>
                      <input type="checkbox"
                             [ngModel]="headerData.drilldown_filter_refresh === '1'"
                             (ngModelChange)="headerData.drilldown_filter_refresh = $event ? '1' : '0'"
                             [name]="'drilldown_refresh_'+i">
                    </div>

                    @if (headerData.data_type === 'number') {
<div class="gb-narrow-col gb-checkbox-field">
                      <label>Round Off</label>
                      <input type="checkbox"
                             [ngModel]="headerData.round_off === '1'"
                             (ngModelChange)="headerData.round_off = $event ? '1' : '0'"
                             [name]="'round_off_'+i">
                    </div>
}

                    <div class="col-md-3">
                      <label>Drill Down:</label>
                      <textarea class="form-control input-sm" placeholder="Enter JSON Object..."
                                [(ngModel)]="headerData.drilldown" [name]="'drilldown_'+i"
                                (ngModelChange)="updateJsonObject(headerData)"></textarea>
                      @if (headerData.isValidate !== false) {
<b style="color: green">Valid Json</b>
}
                      @if (headerData.isValidate === false) {
<b style="color: red">Invalid Json</b>
}
                    </div>

                    <div class="col-md-3">
                      <label>Description:</label>
                      <textarea class="form-control input-sm" placeholder="Enter Description..."
                                [(ngModel)]="headerData.description" [name]="'description_'+i"></textarea>
                    </div>
                  </div>

                </div>
              
}
            </div>
}

          </div>
}

        </div>
      </div>

    </form>
}
  </div>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="saveGrid()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>

  <!-- Confirmation popup for Remove Grid Action -->
  @if (showConfirmRemoveAction) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmRemoveActionConfig"
      [visible]="false"
      (confirmed)="onConfirmRemoveYes()"
      (cancelled)="onConfirmRemoveNo()"
      (closed)="onConfirmRemoveNo()">
    </gtw-confirmation-modal>
  </div>
}

  <!-- Confirmation popup for Delete Header Row -->
  @if (showConfirmDeleteHeader) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmDeleteHeaderConfig"
      [visible]="false"
      (confirmed)="onConfirmDeleteHeaderYes()"
      (cancelled)="onConfirmDeleteHeaderNo()"
      (closed)="onConfirmDeleteHeaderNo()">
    </gtw-confirmation-modal>
  </div>
}
</div>
